import { Link } from 'react-router-dom'
import { ChevronRight, Home } from 'lucide-react'
import { cn } from '@/lib/utils'

export interface BreadcrumbItem {
  label: string
  href?: string
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
  className?: string
}

export function Breadcrumb({ items, className }: BreadcrumbProps) {
  // Prepend Home to the items
  const allItems: BreadcrumbItem[] = [{ label: 'Home', href: '/' }, ...items]

  return (
    <nav aria-label="Breadcrumb" className={cn('flex items-center gap-1 text-sm', className)}>
      {allItems.map((item, index) => {
        const isLast = index === allItems.length - 1
        const isFirst = index === 0

        return (
          <div key={index} className="flex items-center gap-1">
            {index > 0 && <ChevronRight className="text-muted-foreground h-4 w-4" />}
            {isLast ? (
              <span className="text-foreground font-medium">{item.label}</span>
            ) : item.href ? (
              <Link
                to={item.href}
                className="text-muted-foreground hover:text-foreground flex items-center gap-1 transition-colors"
              >
                {isFirst && <Home className="h-4 w-4" />}
                {!isFirst && item.label}
              </Link>
            ) : (
              <span className="text-muted-foreground flex items-center gap-1">
                {isFirst && <Home className="h-4 w-4" />}
                {!isFirst && item.label}
              </span>
            )}
          </div>
        )
      })}
    </nav>
  )
}
